import { PageContentBlock } from 'api/cms';
import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getContentHasBodyHeader({ content }: Props) {
  const firstBlock: PageContentBlock | undefined = content.contentBlocks[0];

  const firstBlockSkipsTitle =
    content.contentBlocks &&
    content.contentBlocks.length > 0 &&
    (['GRAD_CTA_HERO', 'CTA_HERO', 'DONATE'].includes(firstBlock.type) ||
      (firstBlock.type === 'SPLIT_CONTENT' &&
        firstBlock.data.appearance === 'FULL_WIDTH'));

  return !(firstBlockSkipsTitle || content.heroSearch || !content.showTitle);
}
